// /**
//  * Orders - list
//  */

// React
import React from 'react';
import {Link} from 'react-router-dom';

// UI
import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core/styles';
import {
  Chip,
} from '@material-ui/core';

import {translate} from '../../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import RonadIcons from '../../../components/iconComponent';
import SimpleTable, { TheadProps, TbodyProps } from '../../../components/Table/simpleTable';
import SimpleTableBody from '../../../components/Table/tableBody';
import SimpleTableHead from '../../../components/Table/tableHead';

type Props = {
  data: any;
};
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
  })
);

const ticketPriority = {
  LOW: {
    id: 0,
    name: 'LOW',
    title: 'کم',
    color: '#007644',
    bcolor: '#e8faea',
  },
  NORMAL: {
    id: 1,
    name: 'NORMAL',
    title: 'متوسط',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  HIGH: {
    id: 2,
    name: 'HIGH',
    title: 'زیاد',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
  CRITICAL: {
    id: 3,
    name: 'CRITICAL',
    title: 'اضطراری',
    color: 'maroon',
    bcolor: '#fffafa',
  },
};

const headCells = [
  {
    id: 'tracking',
    label: 'شماره تیکت',
    align: 'center',
    format: row => (
      <Link to={`/ticketing/${row.id}`}>
        {row.tracking}
      </Link>
    )
  },
  {
    id: 'creatorId', 
    label: 'از/به',
    format: row => {
      if(row.assignmentType === 'FFC') {
        return <span>{row?.creator?.username} / {row?.department?.name}({row?.assignee?.username})</span>
      }else {
        return <span>{row?.creator?.username} / {row?.assignee?.username}</span>
      }
    }
  },
  {
    id: 'status', 
    label: 'وضعیت',
    format: row => (
      <span>{translate(`${row?.assignee?.type}_${row?.status}`, 'ticket')}</span>
    )
  },
  {
    id: 'updatedAt', 
    label: 'آخرین بروزرسانی',
    format: row => (
      <>
        <span>
          {`${jMoment(row?.updatedAt?.split('T')[1], 'HH:mm:ss')
            .add(3, 'hours')
            .add(30, 'minutes')
            .locale('fa')
            .format('HH:mm')}
            `}
        </span>
        &nbsp;- &nbsp;
        <span>
          {jMoment(row.updatedAt, 'YYYY/M/D')
            .locale('fa')
            .format('jYYYY/jMM/jDD')}
        </span>
      </>
    )
  },
];

const action = (row: any) => (<>
  <div>
    <Link to={`/ticketing/${row.id}`}>
      <RonadIcons className='mr-2 text-green' name='file-05' title="جزئیات سفارش"/>
    </Link>
  </div>
</>)

export default function MobileList(props: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SimpleTable
        defaultOrderBy="updatedAt"
        Thead={
          (prop: TheadProps) => (<SimpleTableHead
            headCells={headCells}
            action={action}
            {...prop}
          />)
        }
        Tbody={(prop: TbodyProps) => (<SimpleTableBody 
          celles={headCells}
          data={props.data}
          {...prop}
        />)}
      />
    </div>
  );
}
